import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; 
import IconItP from '../../app/assets/images/icon/idea-to-product.svg';
import IconIB from '../../app/assets/images/icon/idea-booster.svg';
import IconWD from '../../app/assets/images/icon/web-design.svg';
import IconMobile from '../../app/assets/images/icon/mobile-app.svg';

const Nav = () => {
    const [openMenu, setOpenMenu] = useState(null);

    const handleMenuToggle = (index) => {
        if (openMenu === index) {
            setOpenMenu(null); // Close menu if already open
        } else {
            setOpenMenu(index); // Open menu
        }
    };

    const menuItems = [
        {
            label: 'Solutions',
            link: '#',
            class: 'current',
            megamenu: [
                {
                    section: 'Solutions',
                    items: [
                        { label: 'App Idea to Product', link: '/idea-to-product', target: '_blank', icon: IconItP, subcontent: 'Turn ideas into products' },
                        { label: 'App Idea Booster', link: '/a-idea-booster', target: '_blank', icon: IconIB, subcontent: 'Boost your app ideas' },
                        { label: 'Comprehensive Website Design', link: '/comprehensive-website-design', icon: IconWD, subcontent: 'Explore AI solutions' },
                        { label: 'Mobile App & Software Development', link: '/mobile-software_development', icon: IconMobile, subcontent: 'Efficient call center solutions' },
                    ],
                },
                {
                    section: 'Core Services',
                    items: [
                        { label: 'Generative AI', link: '/generative-ai' },
                        { label: 'IT Support', link: '/it_support' },
                        { label: 'Staffing Solutions', link: '/staffing-support-service' },
                        { label: 'Knowledge Process Outsourcing', link: '/knowledge-process-outsourcing' },
                        { label: 'B2B Lead Generation', link: '/b2b-lead-generation-expert' },
                        { label: 'Plug and Play Call Center Service', link: '/plug-and-play-call-center-service', target: '_blank' },
                        { label: 'Client Success Service', link: '/client-success' },
                    ],
                },
            ],
        },
        {
            label: 'Products',
            link: '/products',
        },
        {
            label: 'About Us',
            link: '#',
            submenu: [
                { label: 'Our Company', link: '/ourcompany' },
                { label: 'Management Team', link: '/mteam' },
                { label: 'Press Release', link: '/pressrelease' },
                { label: 'Careers', link: '/careers' },
            ],
        },
        {
            label: 'Insights',
            link: '#',
            submenu: [
                { label: 'Blog', link: '/blog' },
                { label: 'Case Studies', link: '/casestudy' },
                { label: 'Free Downloads', link: '/freedownload' },
            ],
        },
        {
            label: 'Contact Us',
            link: '/contactus',
        },
    ];

    return (
        <ul className="primary-menu">
            {menuItems.map((item, index) => (
                <li 
                    key={index} 
                    className={item.megamenu || item.submenu ? 'has-submenu' : ''} 
                    onMouseEnter={() => handleMenuToggle(index)}
                    onMouseLeave={() => handleMenuToggle(null)}
                >
                    <Link to={item.link} className='has-subnav-link' onClick={() => handleMenuToggle(index)}>
                        {item.label}
                        {item.megamenu || item.submenu ? (openMenu === index ? <FaChevronDown className="chevron-icon" style={{ fontSize: '16px' }} /> : <FaChevronDown className="chevron-icon" style={{ fontSize: '16px' }} />) : null} {/* Add dropdown icons only if there are submenus */}
                    </Link>
                    {(item.megamenu || item.submenu) && openMenu === index && (
                        <div className={item.megamenu ? "megamenu" : "submenu"}>
                            {item.megamenu && (
                                <>
                                    <div className="megamenu-section-container1">
                                        <h4>{item.megamenu[0].section}</h4>
                                        <ul className='mega-sec-1'>
                                            {item.megamenu[0].items.map((subitem, subindex) => (
                                                <li key={subindex} className="sub-menu-item">
                                                    <Link to={subitem.link} target={subitem.target} className="sub-link">
                                                        <div className='subnav-menu-icon'>
                                                            <img src={subitem.icon} alt={subitem.label} className="icon" />
                                                        </div>
                                                        <div className="sub-menu-content">
                                                            <span>{subitem.label}</span>
                                                            {subitem.subcontent && <p className='mini-text'>{subitem.subcontent}</p>}
                                                        </div>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="megamenu-section-container2">
                                        <h4>{item.megamenu[1].section}</h4>
                                        <ul className='mega-sec-2'>
                                            {item.megamenu[1].items.slice(0, 4).map((subitem, subindex) => (
                                                <li key={subindex} className="sub-menu-item2">
                                                    <Link to={subitem.link} target={subitem.target} className="sub-link">
                                                        {subitem.icon && <img src={subitem.icon} alt={subitem.label} className="icon" />}
                                                        <span>{subitem.label}</span>
                                                        {subitem.subcontent && <p>{subitem.subcontent}</p>}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                        <ul className='mega-sec-2'>
                                            {item.megamenu[1].items.slice(4).map((subitem, subindex) => (
                                                <li key={subindex} className="sub-menu-item2">
                                                    <Link to={subitem.link} target={subitem.target} className="sub-link">
                                                        {subitem.icon && <img src={subitem.icon} alt={subitem.label} className="icon" />}
                                                        <span>{subitem.label}</span>
                                                        {subitem.subcontent && <p>{subitem.subcontent}</p>}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>
                            )}
                            {item.submenu && (
                                <div className="submenu-section">
                                    <ul>
                                        {item.submenu.map((subitem, subindex) => (
                                            <li key={subindex}>
                                                <Link to={subitem.link}>
                                                    {subitem.label}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default Nav;
